module.exports = __webpack_public_path__ + "static/media/no-user.12b69c03.png";